<template>
  <v-dialog :persistent="loading" v-model="dialog" max-width="550">
    <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="billit" class="font-weight-bold" height="35">Add Custom Carrier</v-btn>
    </template>
    
    <v-card>
      <v-card-title>
        Add A Custom Insurance Carrier
        <v-spacer />

        <v-icon aria-label="Close" @click="dialog = false">mdi-close</v-icon>
      </v-card-title>

      <v-card-text class="body-1 text-center">
        <v-form>
          <v-layout align-center justify-center wrap class="my-3">
            <v-scroll-x-transition>
              <v-select
                multiple v-show="useLocations"
                :items="$store.state.locations" :no-data-text="`No ${$store.getters.locL}s on record. Add one from the ${$store.getters.locU}s tab.`"
                :disabled="allLocations" outlined v-model="locations"
                :label="`Choose ${$store.getters.locU}s`"
                item-text="name" item-value="id"
              >
                <template v-slot:selection="{ item, index }">
                  <span style="width: 100%;" :class="{ 'caption': true, 'mt-3': index === 0 && locations.length > 1, 'mt-1': index > 0 && index < locations.length - 1 }"><v-icon color="billit darken-1">mdi-chevron-right</v-icon> {{ item.name }}</span>
                </template>
              </v-select>
            </v-scroll-x-transition>
            <v-flex xs12 style="max-width: 416px;" class="mt-n10">
              <v-checkbox dense class="ml-n8" v-model="allLocations" :label="`All ${$store.getters.locU}s`" color="billit"></v-checkbox>
            </v-flex>            
          </v-layout>

          <v-text-field class="mt-2"
            outlined dense v-model="name"
            label="Name of Carrier"
          ></v-text-field>
          <!-- <v-text-field
            outlined dense v-model="accessCode"
            label="Verify Access Code" type="password"
          ></v-text-field> -->
          <v-divider></v-divider>
          <v-subheader>Glancebar Template for choices under this carrier</v-subheader>
          <v-layout row wrap class="px-1 pb-4">
            <v-flex xs4 class="px-2">
              <v-menu offset-x :close-on-content-click="false" v-model="menu" transition="slide-x-transition">
                <template v-slot:activator="{ on }">
                  <GlanceBarCard add v-on="on" @click.native="menu = true" />
                </template>
                <v-layout column align-center class="white text-center pt-4 px-4">
                  <v-text-field class="white" v-model="addGlanceTitle"
                    outlined dense hide-details style="max-width: 150px;"
                    label="Title" append-icon="mdi-format-font"
                  ></v-text-field>
                  <v-radio-group v-model="addGlanceEnabled" row>
                    <v-radio label="Yes" color="rgb(63, 228, 60)" :value="true"></v-radio>
                    <v-radio label="No" color="rgb(255, 76, 44)" :value="false"></v-radio>
                  </v-radio-group>
                  <v-btn
                    class="mb-3 mx-0 font-weight-medium" color="billit"
                    depressed block @click="glanceItems.push({ title: addGlanceTitle, enabled: addGlanceEnabled, menu: false, }); menu = false"
                    height="30"
                  >Apply</v-btn>
                </v-layout>
              </v-menu>
            </v-flex>
            <v-flex xs4 class="px-2 mb-5" v-for="(item, i) in glanceItems" :key="i">
              <v-menu offset-x :close-on-content-click="false" v-model="item.menu" transition="slide-x-transition">
                <template v-slot:activator="{ on }">
                  <GlanceBarCard :item="item" v-on="on" @click.native="item.menu = true" />
                </template>
                <v-layout column align-center class="white text-center pt-4 px-4">
                  <v-text-field class="white" v-model="item.title"
                    outlined dense hide-details style="max-width: 150px;"
                    label="Title" append-icon="mdi-format-font"
                  ></v-text-field>
                  <v-radio-group v-model="item.enabled" row>
                    <v-radio label="Yes" color="rgb(63, 228, 60)" :value="true"></v-radio>
                    <v-radio label="No" color="rgb(255, 76, 44)" :value="false"></v-radio>
                  </v-radio-group>
                  <v-btn
                    class="mb-3 mx-0 font-weight-medium" color="red"
                    depressed block @click="glanceItems = glanceItems.filter(g => g.title !== item.title); item.menu = false"
                    height="30" rounded outlined
                  >Remove</v-btn>
                </v-layout>
              </v-menu>
            </v-flex>
          </v-layout>
          <p class="font-weight-light text--secondary px-5 mt-3 caption">Any choices added under this carrier will have these Glancebar items added to them by default. You can change them for a specific choice at any time.</p>
          <v-divider></v-divider>
        </v-form>
        <p class="mb-1 mt-3 text--secondary caption">After adding, configure the carrier's choices and preferences to suit your needs.</p>
        <v-btn
          class="mt-3"
          color="info"
          depressed :loading="loading"
          default
          rounded
          @click="addCarrier"
        >Add</v-btn>
        <p v-if="feedback" class="mt-5 red--text">{{ feedback }}</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { functions } from '@/firebase'
import GlanceBarCard from '@/components/misc/GlanceBarCard'

export default {
  components: { GlanceBarCard },
  data() {
    return {
      dialog: false,
      glanceItems: [],
      addGlanceEnabled: true,
      addGlanceTitle: '',
      name: '',
      menu: false,
      feedback: '',
      allLocations: false,
      loading: false,
      // accessCode: '',
      locations: [],
    }
  },
  computed: {
    useLocations() {
      return !this.allLocations
    }
  },
  methods: {
    addCarrier() {
      this.feedback = ''
      this.loading = true
      let f = functions.httpsCallable('addCarrier')
      const locations = this.useLocations ? this.locations : 'all'
      // VVVVVVV if u click off the menu it'll become false anyways
      // let glanceTemplate = []
      // this.glanceItems.forEach(item => glanceTemplate.push({ title: item.title, enabled: item.enabled, menu: false }))
      f({name: this.name, locations, glanceTemplate: this.glanceItems}).then(result => {
        this.name = ''
        this.glanceItems = []
        // this.accessCode = ''
        this.locations = []
        this.loading = false
        this.dialog = false
      })
      .catch(error => {
        this.feedback = error.message
        this.loading = false
      })
    }
  },
  created() {
    this.glanceItems = this.$store.state.practiceData.glanceTemplate
    if (!this.glanceItems) this.glanceItems = []
  }
}
</script>